<!--
 * @Description: 首页（老带新4.0）
 * @Autor: gxd
 * @Date: 2020-10-28 17:34:31
 * @LastEditors: gxd
 * @LastEditTime: 2021-01-11 16:02:54
-->
<template>
  <div :class="['invitation', oldEntrance ? 'invitation-notice' : '']">
    <!--  通知栏-跑马灯 -->
    <div class="invitation-notice-bar" v-if="oldEntrance" @click="go2OldDetail">
      <div class="invitation-notice-bar-left">{{oldEntrance}}</div>
      <div class="invitation-notice-bar-right">查看明细 ></div>
    </div>
    <!-- 规则展示按钮 -->
    <div class="invitation-btn-rule" @click="isShowRule = true"></div>
    <div class="invitation-tabs ignore" ref="invitationTabs" >
      <van-tabs v-model="activeTab" @change="tabChange" @disabled="changeTabToast">
        <van-tab title="第1步 分享海报">
          <!-- 分享海报 -->
          <div class="invitation-posters">
            <savePoster v-if="this.userInfo" @bottomBtn="bottomBtn" @shareSuccess="shareSuccess"></savePoster>
            <div v-if="currentWeekData!='' && Number(currentWeekData.current_week)<10 && Number(currentWeekData.current_week)>0" class="invitation-current-week">第 {{currentWeekData.current_week}} <span class="invitation-current-week-doing">周活动进行中</span>{{currentWeekData.strWeekStart}} - {{currentWeekData.strWeekEnd}}</div>
          </div>
        </van-tab>
        <van-tab title="第2步 上传截图" :disabled="!Number(qualification)">
          <!-- 上传截图 -->
          <ReviewUpload @getReviewStatus="getReviewStatus">
            <ReviewUploadBottom></ReviewUploadBottom>
          </ReviewUpload>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 兑换礼品专区 -->
    <div class="invitation-gifts ignore">
      <div class="invitation-gifts-title">
        <img src="../assets/images/v4.0/gift-title.png" alt="上传图片">
      </div>
      <div class="invitation-gifts-all-times" @click="handleAllTimesClick()">
        <i class="icon icon-gift"></i>
        当前可兑换次数<span>{{currentAllTimes}}</span><div class="right-arrow"><img src="../assets/images/v4.0/arrow-right.png" alt="箭头"></div>
      </div>
      <div class="invitation-gifts-finish">
        <div class="invitation-gifts-finish-content" v-if="isFinishing">活动已结束，兑换次数1月13日失效</div>
      </div>
      <div class="invitation-gifts-content">
        <div class="invitation-gift-item ignore" v-for="(item, index) in gifts" :key="index" @click="selectGift(item)">
          <img class="invitation-gift-img" v-lazy="item.prize_picture?`${item.prize_picture[0]}?x-oss-process=image/resize,p_20`:''" alt="礼品图片">
          <div class="invitation-gift-item-name">{{item.prize_name}}</div>
          <div class="invitation-gift-item-bottom">
            <div class="invitation-gift-item-cost">次数:<span class="times">{{item.prize_price}}</span></div>
            <div class="invitation-gift-item-times">{{item.statisticFormat}}人兑换</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部邀请按钮 -->
    <div :class="['invitation-btn', isShowShareBtn ? 'invitation-btn-show' : 'invitation-btn-hide']"  @click="showPosterShare()">
      <img src="../assets/images/v4.0/share-now.png" alt="立即分享">
    </div>
    <!-- 活动规则弹窗 -->
    <van-popup v-model="isShowRule" class="x-van-popup invitation-popup rule-popup">
      <div class="invitation-popup-close" @click="isShowRule = false"></div>
      <div class="invitation-popup-title">
        <img src="../assets/images/v4.0/rule-title.png" alt="img">
      </div>
      <div class="invitation-popup-content" v-if="rule.content">
        <div class="rule-content-item" v-for="(item,index) in rule.content" :key="index">
          <h5>{{item.title}}</h5>
          <p v-for="(v,i) in item.content" :key="i" v-html="v"></p>
        </div>
      </div>
    </van-popup>
    <!-- 【弹框】礼品详情 -->
    <van-popup v-if="isShowGiftDetailPopup" v-model="isShowGiftDetailPopup" :close-on-click-overlay="false" class="x-van-popup gift-detail-popup">
      <div class="gift-detail-close" @click="closeGiftDetailPopup()">
        <img src="../assets/images/v4.0/close-preview.png">
      </div>
      <div class="gift-detail-top">
        <swiper ref="swiperPic" class="gift-detail-top-swiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in giftDetail.prize_picture" :key="index">
            <div class="gift-detail-img-box">
              <img v-lazy="`${item}?x-oss-process=image/resize,p_20`" alt="无效图片"/>
            </div>
          </swiper-slide>
          <!-- 分页器 -->
          <div v-if="giftDetail.prize_picture && (giftDetail.prize_picture.length > 1)" class="swiper-pagination" id="pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="gift-detail-container">
        <div class="gift-detail-content">
          <div class="gift-detail-content-name">{{giftDetail.prize_name}}</div>
          <div class="gift-detail-content-times">
            <div class="gift-detail-content-cost">次数{{giftDetail.prize_price}}</div>
            <div class="gift-detail-content-exchanges">{{giftDetail.statisticFormat}}人兑换</div>
          </div>
        </div>
        <div class="gift-detail-line"></div>
        <div class="gift-detail-content-des">
          <div class="gift-detail-content-des-gift">礼品说明
            <ul>
              <li v-html="giftDetail.prize_description"></li>
            </ul>
          </div>
          <div class="gift-detail-content-des-exchange">
            兑换说明
            <ul>
              <li v-html="giftDetail.prize_exchange_rule"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="gift-detail-exchange">
        <div :class="['gift-detail-exchange-btn', giftDetail.styleBtn]" @click="giftDetailExchange()">{{giftDetail.strSubmit}}</div>
      </div>
    </van-popup>
    <!-- 【弹框】用户兑换记录 -->
    <van-popup v-model="isShowOperationLog" :class="['gift-operation-log-popup','x-van-popup', operationLogs.list.length>0?'x-van-popup-max':'']" @click="closeExchangeOperationPage()">
      <div class="operation-log-popup-top">
        <img src="../assets/images/v4.0/log-title.png" alt="img">
        <div class="gift-operation-log-popup-times">
          <div class="gift-operation-log-popup-times-item">总获得次数：<span>{{operationLogs.issue}}</span></div>
          <div class="gift-operation-log-popup-times-item">已消耗次数：<span>{{operationLogs.consume}}</span></div>
        </div>
      </div>
      <div class="operation-log-popup-content">
        <!-- 有兑换记录，列表展示 -->
        <ul v-if="operationLogs.list && (operationLogs.list.length > 0)">
          <li v-for="(item, index) in operationLogs.list" :key=index>
            <div class="operation-log-popup-left">
              <div class="operation-log-popup-left-top">
                {{item.operation_type == 1 ? "分享海报成功" :`兑换【${item.prize_name}】`}}
              </div>
              <div class="operation-log-popup-left-bottom">
                {{item.belong_time}}
              </div>
            </div>
            <div class="operation-log-popup-right">
              {{item.operation_type == 1 ? "+" : "-"}}{{item.reward}}
            </div>
          </li>
        </ul>
        <!-- 无兑换记录 -->
        <div v-else class="operation-log-default-img-box">
          <img src="../assets/images/v4.0/exchange-log-default.png" alt="无操作记录">
          <div class="operation-log-default-desc">- 暂时没有兑换记录 -</div>
        </div>
      </div>
      <!-- 关闭按钮 -->
      <div class="operation-close" @click="closeExchangeOperationPage()"></div>
    </van-popup>
    <!-- 【弹框】地址确认 -->
    <addressConfirm :isShow="isShowAddressConfirm" @exchangeCancel="exchangeCancel" @exchangeConfirm="exchangeConfirm"></addressConfirm>
    <!-- 【弹框】兑换成功提示 -->
    <exchangeSuccess :isShow="isShowExchangeSuccessPopup" @closePopup="closeExchangeSuccessPopup"></exchangeSuccess>
    <!-- 【弹框】图片分享成功 -->
    <van-popup class="share-success-popup" v-model="isShowShareSuccess" @click="isShowShareSuccess=false">
      <div class="share-success-popup-close" @click="isShowShareSuccess=false"></div>
      <div class="share-success-popup-container">
        <!-- <div class="share-success-popup-img">
          <img src="../assets/images/v4.0/success-check.png" alt="成功">
        </div> -->
        <div class="share-success-popup-title">海报分享成功后</div>
        <div class="share-success-popup-tips">请至少在朋友圈保留2小时后上传截图</div>
      </div>
      <div class="share-success-popup-footer">
        <div class="popup-close" @click="isShowShareSuccess=false">
          好的
        </div>
      </div>
    </van-popup>
    <!-- 活动将要结束弹框 -->
    <van-popup class="finish-popup" v-model="isShowFinish" :close-on-click-overlay="false">
      <div @click="closeFinishPopup" class="finish-popup-footer">
        我知道了
      </div>
    </van-popup>
    <!-- 未登录处理组件 -->
    <login-handle ref="loginHandle" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import xes from '@xes/app-jssdk'
import savePoster from './savePoster'
import rule from '../assets/js/rule.js'
import 'swiper/dist/css/swiper.min.css'
import LoginHandle from '../components/LoginHandle'
import addressConfirm from '../components/AddressConfirm'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import exchangeSuccess from '../components/ExchangeSuccess' // 兑换成功弹框
import ReviewUpload from '../components/ReviewUpload' // 审核上传
import ReviewUploadBottom from '../components/ReviewUploadBottom' // 审核上传底部
import TimeFormat from '../utils/TimeFormat' // 参数格式化

export default {
  name: 'Home',
  components: { LoginHandle, savePoster, swiper, swiperSlide, addressConfirm, exchangeSuccess, ReviewUpload, ReviewUploadBottom },
  computed: mapState(['userInfo', 'selectedGift', 'defaultAddress', 'currentAllTimes', 'qualification', 'addressPopup', 'uploadStatus', 'currentWeekIndex', 'isFinishing']),
  data () {
    return {
      rule: rule, // 活动规则内容
      oldEntrance: '', // 旧版入口描述
      isShowRule: false, // 是否展示规则弹窗
      isShowGiftDetailPopup: false, // 是否展示礼品详情弹框
      gifts: [], // 礼品列表（通过礼品列表接口获取）
      giftDetail: '', // 礼品详情（通过详情接口获取）
      currentWeekData: '', // 当前周
      activeTab: 0,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }, // 分页器
        autoplay: 2000,
        speed: 600,
        on: { // 监听swiper的滑动操作
          slideChange: function () {
            console.log('slideChange')
          }
        },
        initialSlide: 0
      },
      isShowAddressConfirm: false, // 是否展示地址确认
      isShowOperationLog: false, // 是否展示兑换记录
      operationLogs: {
        consume: 0,
        issue: 0,
        list: []
      }, // 兑换记录
      isShowShareBtn: false, // 是否展示底部分享按钮
      isShowExchangeSuccessPopup: false, // 是否展示兑换成功弹框
      isShowPreview: false, // 是否展示图片预览
      isShowShareSuccess: false, // 是否展示分享成功
      isShowFinish: false,
      offsetForShowBottomBtn: 450,
      isRequesting: false
    }
  },
  watch: {
    isShowRule (val) {
      if (val) {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '老带新APP活动主页',
            element_action: 'click',
            element_value: '”规则“按钮点击'
          }
        })
      }
    },
    activeTab (val) {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '老带新APP活动主页',
          element_action: 'click',
          element_value: val === 0 ? 'tab“分享海报”点击' : 'tab“上传截图”点击'
        }
      })
      this.$nextTick(() => {
        console.log('tabChange---nextTick')
        const temp = this.uploadStatus
        this.$store.dispatch('storeUploadStatus', {})
        this.$nextTick(() => {
          this.$store.dispatch('storeUploadStatus', temp)
        })
      })
    },
    isShowGiftDetailPopup (val) {
      // 隐藏弹框时，重新加载列表数据
      if (!val) {
        this.$refs.swiperPic.swiper.slideTo(0, 0, false)
        this.loadGiftData()
      }
    },
    // 上传截图二次确认
    isShowUploadConfirm (val) {
      if (val) {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '截图审核',
            element_action: 'show',
            element_value: '截图审核-二次确认弹框-展示'
          }
        })
      }
    }
  },
  created () {
    this.$toast.clear()
    this.$xesLogger.clickMsg({
      params: {
        elementname: '老带新APP活动主页',
        element_action: 'pv',
        element_value: '老带新APP活动主页'
      }
    })
    // 判断活动是否将要结束
    this.judgeIsFinishing()
    this.isShowFinish = this.isFinishing
  },
  mounted () {
    if (!this.userInfo) return this.$refs.loginHandle.callLogin()
    // 获取页面基础数据
    this.getBasicPageData()
    if (window.xesShare.shareClient === 2) {
      // 隐藏右上角菜单（...）功能
      xes.setTitleMenu(0) // de-bug
    }
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(() => {
      this.bottomBtn()
    })
    this.isShowAddressConfirm = this.addressPopup
  },
  methods: {
    /**
     ************ 初始化 ***********
     */
    // 获取页面基础数据
    getBasicPageData () {
      // 获取旧版入口
      this.getOldEntrance()
      // 图片审核状态
      this.getReviewStatus()
      // 获取地址（中台)(确认兑换后)
      this.addrInfos()
      // 用户权限，是否可以参与活动
      this.getQualification()
      // 加载（重新加载）礼品信息
      this.loadGiftData()
      // 获取当前周信息
      this.getCurrentWeek()
    },
    // 判断是否将要结束
    judgeIsFinishing () {
      const date = '2021/01/10 23:59:59' // 提醒活动即将结束的日期
      const timeFinishing = new Date(date).getTime()
      const timeNow = new Date().getTime()
      this.$store.dispatch('storeIsFinishing', timeNow > timeFinishing)
    },
    tabChange () {
      console.log('tabChange---')
      this.$nextTick(() => {
        console.log('tabChange---nextTick')
        const temp = this.uploadStatus
        this.$store.dispatch('storeUploadStatus', temp)
      })
    },
    // 加载（重新加载）礼品信息
    loadGiftData () {
      // 获取当前可用次数
      this.getCurrentAllTimes()
      // 获取礼品列表
      this.getGiftList()
    },
    /**
     * *********** 页面事件 **********
     */
    // 【事件】跳转3.0版本老带新-奖励详情页
    go2OldDetail () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '老带新APP活动主页',
          element_action: 'click',
          element_value: '跑马灯“查看明细”按钮点击'
        }
      })
      this.$router.push({ name: 'rewardPage' })
    },
    // 【事件】点击可兑换次数变更记录，既操作记录
    handleAllTimesClick () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '礼品兑换',
          element_action: 'click',
          element_value: '当前可兑换次数点击'
        }
      })
      // 获取操作记录
      this.getGiftOperationLog()
    },
    // 【事件】选择礼品，请求详情
    selectGift (item) {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '礼品兑换',
          element_action: 'click',
          element_value: '礼品卡片点击',
          gift_id: item.id,
          gift_name: item.prize_name
        }
      })
      this.$store.dispatch('changeSelectedGift', item)
      this.getGiftDetail(item)
    },
    // 【事件】展示分享
    showPosterShare () {
      // 滚动到制定位置
      window.scrollTo(0, 0)
    },
    // 【事件】点击不可用tab时进行提示
    changeTabToast () {
      this.$toast('只有同步课在读用户才能参加活动哦~')
    },
    // 【事件】地址确认弹框，关闭
    exchangeCancel () {
      this.isShowAddressConfirm = false
      this.$store.dispatch('showAddressPopup', false)
    },
    // 【事件】地址确认弹框，确认
    exchangeConfirm () {
      if (this.isRequesting) {
        return
      }
      this.$xesLogger.clickMsg({
        params: {
          elementname: '礼品兑换',
          element_action: 'click',
          element_value: '确认兑换弹窗“确认兑换”按钮点击',
          gift_id: this.giftDetail.id,
          gift_name: this.giftDetail.prize_name
        }
      })
      // 根据地址进行兑换
      console.log('===', this.selectedGift.id, this.selectedGift.prize_price, this.selectedGift, this.currentAllTimes)
      if (this.selectedGift.prize_price <= this.currentAllTimes) {
        this.isRequesting = true
        this.$toast.loading({
          forbidClick: true,
          message: '兑换中...',
          duration: 0
        })
        this.$api.giftExchange(this.selectedGift.id, this.defaultAddress.id).then(res => {
          this.$toast.clear()
          this.isRequesting = false
          this.$store.dispatch('showAddressPopup', false)
          // 可以正常兑换
          console.log('兑换结果===', res)
          if (res.code === 0) {
            this.isShowAddressConfirm = false
            this.isShowExchangeSuccessPopup = true
            // 加载礼品数据
            this.loadGiftData()
          } else {
            this.$toast('兑换失败')
          }
        }).catch((e) => {
          console.log(e)
          this.$toast.clear()
          this.isRequesting = false
          this.$store.dispatch('showAddressPopup', false)
        })
      } else {
        this.$toast('兑换次数不足')
      }
    },
    // 【事件】礼品详情展示弹框-关闭
    closeGiftDetailPopup () {
      this.isShowGiftDetailPopup = false
      this.$xesLogger.clickMsg({ params: { action: 'closeGiftDetailPopup', clickid: '5.3.23' } })
    },
    // 【事件】关闭操作记录弹框
    closeExchangeOperationPage () {
      this.isShowOperationLog = false
    },
    // 【事件】关闭兑换成功弹框
    closeExchangeSuccessPopup () {
      this.isShowExchangeSuccessPopup = false
    },
    // 【事件】兑换，去兑换地址
    giftDetailExchange () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '礼品兑换',
          element_action: 'click',
          element_value: '礼品详情弹窗“立即兑换”按钮点击',
          gift_id: this.giftDetail.id,
          gift_name: this.giftDetail.prize_name
        }
      })
      // 是否有默认地址，有，则提示兑换，无，则进入地址填写也
      if (Number(this.giftDetail.prize_status) === 2) {
        // this.$toast('已抢光')
        return
      } else if (this.giftDetail.prize_price > this.currentAllTimes) {
        this.$toast('兑换次数不足')
        return
      }
      console.log(this.defaultAddress)
      if (Boolean(this.defaultAddress) === true) {
        this.isShowGiftDetailPopup = false
        this.isShowAddressConfirm = true
        this.$store.dispatch('showAddressPopup', true)
      } else {
        this.isShowGiftDetailPopup = false
        const route = { name: 'address' }
        this.$router.push(route)
      }
    },
    /**
     * *********** 数据请求 ***********
     */
    // 【数据】获取旧版入口，是否展示旧版老带新
    getOldEntrance () {
      this.oldEntrance = '您的邀好友返学费奖励请点击这里查询'
      this.$api.getOldEntrance().then(res => {
        if ((res.stat === 1) && (res.data.haveAward === 1)) {
          // 返回成功且有奖励，展示入口
          this.oldEntrance = '您的邀好友返学费奖励请点击这里查询'
        } else {
          // 不展示
          this.oldEntrance = ''
        }
      })
    },
    // 获取当前周
    getCurrentWeek () {
      this.$api.getCurrentWeek().then(res => {
        console.log('week---', res.data)
        if (res.data) {
          this.currentWeekData = res.data
          this.currentWeekData.strWeekStart = TimeFormat.timeToMonthDay(this.currentWeekData.week_start)
          this.currentWeekData.strWeekEnd = TimeFormat.timeToMonthDay(this.currentWeekData.week_end)
          this.$store.dispatch('storeCurrentWeekIndex', this.currentWeekData.current_week)
        }
      })
    },
    // 获取用户资格
    getQualification () {
      this.$api.getQualification().then(res => {
        console.log('getQualification====', res)
        // res.data.result = false
        if (res.data) {
          this.$store.dispatch('storeQualification', res.data.result)
          // 增加公共埋点
          this.$xesLogger.opts.param.qualification = res.data.result ? '1' : '0'
          this.$xesLogger.clickMsg({
            params: {
              elementname: '老带新APP活动主页',
              element_action: 'show',
              element_value: '老带新APP活动主页'
            }
          })
        }
      })
    },
    // 【数据】获取当前可用次数
    getCurrentAllTimes () {
      this.$api.getCurrentAllTimes().then(res => {
        console.log('getCurredddntTimes====', res.data.reward)
        this.$store.dispatch('changeCurrentAllTimes', res.data.reward)
      })
    },
    // 【数据】获取图片审核状态及应展示的图片信息
    getReviewStatus () {
      // const temp = {
      //   upload: false,
      //   review_status: 0,
      //   upload_url: 'http://'
      // }
      const statusTemp = {}
      statusTemp.upload = false
      statusTemp.review_status = -2
      statusTemp.localImage = ''
      statusTemp.localBlackBg = true
      statusTemp.upload_url = ''
      this.$store.dispatch('storeUploadStatus', statusTemp)
      this.$api.getUserUploadStatus().then(res => {
        // 返回成功
        if (res.code === 0) {
          this.$store.dispatch('storeUploadStatus', res.data)
        }
      })
    },
    // 用户图片审核结果回调
    getImageReviewCallBack () {
      this.$api.getImageReviewCallBack().then(res => {
        console.log('===用户图片审核结果回调', res)
      })
    },
    // 用户礼品操作记录
    // 【数据】用户礼品操作记录
    getGiftOperationLog () {
      this.$api.getGiftOperationLog().then(res => {
        if (res.code === 0) {
          this.operationLogs = res.data
          this.isShowOperationLog = true
        } else {
          this.$toast('获取数据失败')
        }
      })
    },
    // 【数据】获取礼品列表
    getGiftList () {
      this.$api.getGiftList().then(res => {
        console.log('礼品列表===', res)
        if (res.code === 0) {
          this.gifts = res.data.list
          for (let i = 0; i < this.gifts.length; i++) {
            const item = this.gifts[i]
            if (parseInt(item.statistic) >= 10000) {
              const temp = parseInt(item.statistic)
              item.statisticFormat = Math.floor(temp / 1000) / 10 + ' 万'
            } else {
              item.statisticFormat = item.statistic
            }
          }
        }
      })
    },
    // 【数据】获取礼品详情
    getGiftDetail (item) {
      // 可以正常兑换
      this.$api.getGiftDetail(item.id).then(res => {
        console.log('礼品详情===', res)
        // 可以正常兑换
        this.giftDetail = res.data
        if (parseInt(this.giftDetail.statistic) >= 10000) {
          const temp = parseInt(this.giftDetail.statistic)
          this.giftDetail.statisticFormat = Math.floor(temp / 1000) / 10 + ' 万'
        } else {
          this.giftDetail.statisticFormat = this.giftDetail.statistic
        }
        this.giftDetail.strSubmit = '立即兑换'
        this.giftDetail.styleBtn = ''
        if (Number(this.giftDetail.prize_status) === 2) {
          this.giftDetail.strSubmit = '已抢光'
          this.giftDetail.styleBtn = 'gift-detail-exchange-btn-gray'
        } else if (this.giftDetail.prize_price > this.currentAllTimes) {
          this.giftDetail.strSubmit = '兑换次数不足'
          this.giftDetail.styleBtn = 'gift-detail-exchange-btn-gray'
        }
        this.isShowGiftDetailPopup = true
      })
    },
    // 上传确认弹框-确认
    uploadConfirm () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '截图审核',
          element_action: 'click',
          element_value: '截图审核-二次确认弹框-确定按钮-点击'
        }
      })
      this.uploadFile(this.selectedFile)
    },
    // 上传确认弹框-取消
    uploadCancel () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '截图审核',
          element_action: 'click',
          element_value: '截图审核-二次确认弹框-重新选图按钮-点击'
        }
      })
      this.isShowUploadConfirm = false
      this.$refs.vanUploader.$refs.input.click()
    },
    // 获取地址（中台)(确认兑换后)
    // 【数据】获取地址（中台)(确认兑换后)
    addrInfos () {
      this.$api.addrInfos().then((res) => {
        if (res.stat !== 1) {
          this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=9` })
          return false
        }
        if (res.data.total !== 0) {
          this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=10` })
          let defAdd = ''
          // 获取默认地址
          for (const addr of res.data.list) {
            if (addr.is_default === '1') {
              defAdd = addr
            }
          }
          // 无默认，则用第一个
          if (Boolean(defAdd) === false) {
            defAdd = res.data.list[0]
          }
          this.$store.dispatch('changeDefaultAddress', defAdd)
        }
      }).catch((e) => {
        this.$toast.clear()
        console.log(e)
      })
    },
    /**
     * *********** 页面回调 ***********
     */
    // 分享成功
    shareSuccess () {
      this.activeTab = 1
      this.isShowShareSuccess = true
    },
    // 计算按钮显示
    bottomBtn () {
      console.log('created-----', this.$refs.invitationTabs.offsetTop, this.$refs.invitationTabs.offsetHeight)
      this.offsetForShowBottomBtn = this.$refs.invitationTabs.offsetTop + this.$refs.invitationTabs.offsetHeight - 42
    },
    // 创建模拟数据
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > this.offsetForShowBottomBtn) {
        this.isShowShareBtn = true
      } else if (scrollTop <= this.offsetForShowBottomBtn) {
        this.isShowShareBtn = false
      }
    },
    closeFinishPopup () {
      this.isShowFinish = !this.isShowFinish
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../assets/scss/homePage/index.less');
</style>
